<template>
  <div class="flex flex-col w-full">
    <div v-if="ordersLoading">
      {{ $t("production_order_list.orders_table.loading") }}
    </div>
    <div v-else>
      <div v-if="itemsForQueue.length === 0">
        {{ $t("production_order_list.orders_table.no_orders_found") }}
      </div>
      <div v-else>
        <!-- Retailer is the same for every item in queue for this table, so we can use the retailer of the first queueitem-->
        <b
          >{{ $t("production_order_list.orders_table.header") }} -
          {{ itemsForQueue[0].retailer.name }}</b
        >

        <table
          class="table-fixed w-full border-solid px-4 mt-3 data-table-right-section overflow-y-auto table-parent"
        >
          <thead>
            <tr>
              <th class="w-2/12 px-2 pb-2 text-left font-semibold">
                {{
                  $t("production_order_list.order_table.columns.order_number")
                }}
              </th>
              <th class="w-2/12 px-2 pb-2 text-left font-semibold">
                {{ $t("production_order_list.order_table.columns.brand") }}
              </th>
              <th class="w-2/12 px-2 pb-2 text-left font-semibold">
                {{ $t("production_order_list.order_table.columns.product") }}
              </th>
              <th class="w-2/12 px-2 pb-2 text-left font-semibold">
                {{ $t("production_order_list.order_table.columns.style") }}
              </th>
              <th class="w-2/12 px-2 pb-2 text-left font-semibold">
                {{ $t("production_order_list.order_table.columns.tailoring") }}
              </th>
              <th class="w-2/12 px-2 pb-2 text-left font-semibold">
                {{ $t("production_order_list.order_table.columns.date") }}
              </th>
              <th class="w-2/12 px-2 pb-2 text-left font-semibold">
                {{ $t("production_order_list.order_table.columns.status") }}
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in itemsForQueue"
              :key="index"
              v-bind:class="[
                'hover:bg-gray-50',
                index === itemsForQueue.length - 1 ? '' : 'border-b'
              ]"
            >
              <td class="py-3 px-2 text-left text-sm">
                {{ item.order_number }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ item.brand.name }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ item.product.name }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ item.style.name }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ item.tailoring }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ formatDate(item.created_at) }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{
                  $t(
                    `general.status.retailer_order.${item.status.toLowerCase()}`
                  )
                }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                <dots-dropdown>
                  <div
                    v-if="canDoOrderAction('view', item.status)"
                    class="dropdown-item"
                    @click="handleView(item)"
                  >
                    {{ $t("production_order_list.order_table.menu.view") }}
                  </div>
                  <div
                    v-if="canDoOrderAction('edit', item.status)"
                    class="dropdown-item"
                    @click="handleEdit(item)"
                  >
                    {{ $t("production_order_list.order_table.menu.edit") }}
                  </div>
                  <div
                    v-if="canDoOrderAction('showMeasurements', item.status)"
                    class="dropdown-item"
                    @click="handleMeasurements(item)"
                  >
                    {{
                      $t(
                        "production_order_list.order_table.menu.body_measurements"
                      )
                    }}
                  </div>
                </dots-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DotsDropdown from "@/components/general/dots-dropdown.vue";
import { RetailerOrderStatus } from "@/enums";
import moment from "moment/moment";

export default {
  name: "ProductionOrderOrdersTable",
  computed: {
    RetailerOrderStatus() {
      return RetailerOrderStatus;
    }
  },
  components: { DotsDropdown },
  props: {
    itemsForQueue: {
      type: Array,
      default: () => []
    },
    ordersLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    canDoOrderAction(action, orderStatus) {
      switch (action) {
        case "view":
          return true;
        case "edit":
          return (
            orderStatus === RetailerOrderStatus.NEW ||
            orderStatus === RetailerOrderStatus.IN_PROGRESS ||
            orderStatus === RetailerOrderStatus.IN_REVIEW
          );
        case "showMeasurements":
          return true;
        default:
          return false;
      }
    },
    handleView(queueItem) {
      this.$emit("handle-view", queueItem);
    },
    handleEdit(queueItem) {
      this.$emit("handle-edit", queueItem);
    },
    handleMeasurements(queueItem) {
      this.$emit("handle-measurements", queueItem);
    },
    formatDate(date) {
      return moment(date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY");
    }
  }
};
</script>
